/* eslint-disable react-hooks/exhaustive-deps */

import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  I2cBrand,
  I2cIcon,
  I2cButton,
  I2cInput,
  I2cSwitch,
} from "@webcomponents/i2cwebcomponents/dist/react";
import AsideSection from "../../../Components/AsideSection/AsideSection";
// @ts-expect-error
import logo from "../../../assets/images/i2c_logo.svg";
// @ts-expect-error
import banner from "../../../assets/images/login_art.svg";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";
import ConfirmaionModal from "../../../Components/ConfirmationModal/ConfirmationModal";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthHeadDesc from "../../../Components/SharedComponent/AuthHeaderSection/AuthHeaderSection";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
// import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { validationSchema } from "./ValidationSchema";
import { useMutation } from "react-query";
import AuthService from "../../../Services/AuthServices";
import "./Login.scss";
import "../../../Utils/shared-styles/Authentication.scss";
import AlertMessage from "../../../Components/SharedComponent/Alert/Alert";
import { UserStateContext } from "../../../Context/AuthContext";
import DarkModeBtn from "../../../Components/DarkModeBtn/DarkModeBtn";
import microSoftIcon from "../../../../src/assets/images/microsoft-icon.svg";
const LoginPage = () => {
  const form = useRef();
  const userEmail = useRef();
  const AuthContext = UserStateContext();
  const [recaptcha, setRecaptcha] = useState('');
  const [reValidateRecaptcha, setReValidateRecaptcha] = useState(false);
  const [showConfirmatonModal, setShowConfirmatonModal] = useState(false);
  const navigate = useNavigate();
  const [searchParam] = useSearchParams();
  const isSetPasswordSuccess = searchParam.get('set-password');
  const [statusUrl, setStatusUrl] = useState(false);
  const [codeUrl, setCodeUrl] = useState({
    code: false,
    state: false,
    sessionState: false,
  });
  const [popUp, setPopUp] = useState(false);
  const [errorState, setErrorState] = useState({
    isError: false,
    message: '',
    source: '', // 'email' or 'azure'
  });

  const onVerify = useCallback((token) => {
    setReValidateRecaptcha(false);
    setRecaptcha(token);
  }, []);

  const loginWithAzure = useMutation({
    mutationFn: async () => {
      return await AuthService.getAzureData();
    },
    onSuccess: (response) => {
      if (response.data.status) {
        setStatusUrl(response.data);
      }
    },
    onError: (error) => {
      setReValidateRecaptcha(true);
      setErrorState({
        isError: true,
        message: error?.response?.message || 'Azure authentication failed.',
        source: 'azure',
      });
    },
  });

  useEffect(() => {
    loginWithAzure.mutate();
  }, []);

  const handleStatusWindow = () => {
    setErrorState({ isError: false, message: '', source: '' }); // Reset error state
    if (statusUrl.url) {
      const windowWidth = 500;
      const windowHeight = 600;
      const left = (window.screen.width - windowWidth) / 2;
      const top = (window.screen.height - windowHeight) / 2;
      const windowFeatures = `width=${windowWidth},height=${windowHeight},left=${left},top=${top},resizable=yes`;
      const popUpWindow = window.open(statusUrl.url, 'PopupWindow', windowFeatures);

      if (popUpWindow) {
        setPopUp(popUpWindow);

        const interval = setInterval(() => {
          try {
            if (popUpWindow.location.href.includes('?')) {
              const vars = [];
              const hashes = popUpWindow.location.href
                .slice(popUpWindow.location.href.indexOf('?') + 1)
                .split('&');
              const params = {};
              for (let i = 0; i < hashes.length; i++) {
                const hash = hashes[i].split('=');
                vars.push(hash[0]);
                params[hash[0]] = decodeURIComponent(hash[1]);
              }
              if (params.code && params.state && params.session_state) {
                setCodeUrl((prevState) => ({
                  ...prevState,
                  code: params.code,
                  state: params.state,
                  sessionState: params.session_state,
                }));
                clearInterval(interval);
              }
            }
          } catch (error) {
            if (popUpWindow.closed) {
              clearInterval(interval);
            }
            console.error('Error accessing popup window URL', error);
          }
        }, 500);
      }
    }
  };

  useEffect(() => {
    if (codeUrl.code && codeUrl.state && codeUrl.sessionState) {
      sendCodeUrlRequest.mutate(codeUrl);
    }
  }, [codeUrl]);

  useEffect(() => {
    let interval;
    if (popUp) {
      interval = setInterval(() => {
        if (popUp.closed) {
          clearInterval(interval);
          setPopUp(null);
          onPopupClosed();
        }
      }, 500);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [popUp]);

  const onPopupClosed = () => {
    setPopUp(false);
  };

  const sendCodeUrlRequest = useMutation({
    mutationFn: async (values) => {
      return await AuthService.postAzureData(values);
    },
    onSuccess: async (data) => {
      AuthContext.setToken(data.data.token);
      AuthContext.setSessionCount(data.data.sessionCount);
      // Backend sends encrypted roleId and roleName - use them directly
      const encryptedRoleId = data.data.roleId || '';
      const encryptedRoleName = data.data.roleName || '';
      const { roleId, roleName } = await AuthContext.setUserRole(encryptedRoleId, encryptedRoleName);
      if (data?.data?.temporaryPwd || data?.data?.passwordExpired) {
        AuthContext.setIsTempPwd(true);
        navigate('/set-password');
      } else {
        if (data.data.sessionCount > 0) {
          navigate('/concurrent-sessions');
        } else {
          // Check for redirect URL from sessionStorage
          const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
          if (redirectUrl) {
            sessionStorage.removeItem('redirectAfterLogin');
            navigate(redirectUrl);
          } else {
            // Default redirect based on user role
            if (roleId === '5' || roleName === 'client') {
              navigate('/impl');
            } else {
              navigate('/sales');
            }
          }
        }
      }
      if (popUp) {
        popUp.close();
      }
    },
    onError: (error) => {
      setReValidateRecaptcha(true);
      let errorMessage = error?.response?.data?.message || error?.response?.message || 'Azure login failed.';
      
      // Check for recaptcha errors and append them
      const recaptchaErrors = error?.response?.data?.errors?.recaptcha;
      if (recaptchaErrors && Array.isArray(recaptchaErrors) && recaptchaErrors.length > 0) {
        errorMessage = `${errorMessage} ${recaptchaErrors.join(' ')}`;
      }
      
      setErrorState({
        isError: true,
        message: errorMessage,
        source: 'azure',
      });
      if (popUp) {
        popUp.close();
      }
    },
  });

  const login = useMutation({
    mutationFn: async (values) => {
      return await AuthService.login({ ...values, recaptcha });
    },
    onSuccess: async (data) => {
      AuthContext.setToken(data.data.token);
      AuthContext.setSessionCount(data.data.sessionCount);
      // Backend sends encrypted roleId and roleName - use them directly
      const encryptedRoleId = data.data.roleId || '';
      const encryptedRoleName = data.data.roleName || '';
      const { roleId, roleName } = await AuthContext.setUserRole(encryptedRoleId, encryptedRoleName);
      if (data?.data?.temporaryPwd || data?.data?.passwordExpired) {
        AuthContext.setIsTempPwd(true);
        navigate('/set-password');
      } else {
        if (data.data.sessionCount > 0) {
          navigate('/concurrent-sessions');
        } else {
          // Check for redirect URL from sessionStorage
          const redirectUrl = sessionStorage.getItem('redirectAfterLogin');
          if (redirectUrl) {
            sessionStorage.removeItem('redirectAfterLogin');
            navigate(redirectUrl);
          } else {
            // Default redirect based on user role
            if (roleId === '5' || roleName === 'client') {
              navigate('/impl');
            } else {
              navigate('/sales');
            }
          }
        }
      }
    },
    onError: (error) => {
      setReValidateRecaptcha(true);
      let errorMessage = error?.response?.data?.message || error?.response?.message || 'Email/Password login failed.';
      
      // Check for recaptcha errors and append them
      const recaptchaErrors = error?.response?.data?.errors?.recaptcha;
      if (recaptchaErrors && Array.isArray(recaptchaErrors) && recaptchaErrors.length > 0) {
        errorMessage = `${errorMessage} ${recaptchaErrors.join(' ')}`;
      }
      
      setErrorState({
        isError: true,
        message: errorMessage,
        source: 'email',
      });
    },
  });

  const handleLogin = (data) => {
    setErrorState({ isError: false, message: '', source: '' }); // Reset error state on login attempt
    if (recaptcha) {
      login.mutate(data);
    } else {
      setErrorState({
        isError: true,
        message: 'Please complete the reCAPTCHA verification.',
        source: 'email',
      });
    }
  };

  const methods = useForm({
    resolver: zodResolver(validationSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    shouldUseNativeValidation: false,
    criteriaMode: 'firstError',
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const watchEmail = methods.watch('email');
  const isAzureLogin =
    watchEmail?.toLowerCase()?.includes('@i2cinc.com') &&
    !['admin@i2cinc.com', 'superadmin@i2cinc.com', 'manager@i2cinc.com', 'sales@i2cinc.com','nhaq@i2cinc.com','client@i2cinc.com', 'sale@i2cinc.com'].includes(
      watchEmail?.toLowerCase()
    );

  const {
    handleSubmit,
    formState: { errors, isValid },
  } = methods;

  const handleButtonClick = () => {
    navigate('.', { replace: true });
  };

  return (
    <React.Fragment>
      <div className="layout_aside">
        <div className="layout_aside-left">
          <AsideSection
            image={banner}
            heading={
              <span>
                Commitment to delivering <br /> exceptional solutions
              </span>
            }
            description="customer-centric approach and dedication to driving success through seamless implementations"
          />
        </div>
        <div className="layout_aside-right forStandAlone">
          <div className="right-container">
            <div className="login auth__main-right">
              <div className="dark-mode-btn-wrapper">
                <DarkModeBtn />
              </div>
              <div className="auth__right-content">
                <div className="login__content-wrapper auth__content-wrapper">
                  <header id="header">
                    <I2cBrand
                      className="login__logo"
                      label="Client Implementation Portfolio"
                      logo={logo}
                      slot="brand"
                      style={{
                        '--brand-logo-img-width': '2.5rem',
                        '--brand-logo-img-height': 'auto',
                      }}
                      target=""
                    />
                  </header>
                  <AuthHeadDesc
                    classNameHeader="login-page-header"
                    title="Sign in to Your Account"
                    description="Please enter your User ID and Password to sign in."
                  />
                  <div className="login__form">
                    {errorState.isError && (
                      <div className="alert-message-section-login">
                        <AlertMessage
                          open={true}
                          message={errorState.message}
                          variant="danger"
                        />
                      </div>
                    )}
                    {isSetPasswordSuccess && (
                      <div onClick={handleButtonClick}>
                        <AlertMessage
                          variant="success"
                          message="Password updated successfully"
                          headerArt="linear-tick-circle"
                          open={true}
                          closeAble={true}
                        />
                      </div>
                    )}
                    <form
                      onSubmit={handleSubmit(handleLogin)}
                      ref={form}
                      autoComplete="on"
                    >
                      <div className={` ${!isAzureLogin ? 'login__form-group login__userID-group' : ''}`}>
                        <Controller
                          name="email"
                          control={methods.control}
                          render={({ field }) => (
                            <I2cInput
                              size="large"
                              label="User Email"
                              placeholder="user@i2cinc.com"
                              name="email"
                              type="email"
                              required
                              className="auth__custom-input fw-400"
                              autofocus
                              invalid={errors.email || errorState.source === 'email'}
                              ref={userEmail}
                              onI2cInput={(val) => {
                                if (errorState.source === 'email') {
                                  setErrorState({ isError: false, message: '', source: '' });
                                }
                                field.onChange(val);
                              }}
                              onI2cBlur={field.onBlur}
                            >
                              {errorState.source === 'email' && (
                                <I2cIcon
                                  slot="suffix"
                                  color="red"
                                  name="cs-linear-alert-circle"
                                />
                              )}
                            </I2cInput>
                          )}
                        />
                      </div>
                      {!isAzureLogin && (
                        <div className="login__form-group login__password-group">
                          <Controller
                            name="password"
                            control={methods.control}
                            render={({ field }) => (
                              <I2cInput
                                size="large"
                                type="password"
                                label="Password"
                                placeholder="Enter Password"
                                name="password"
                                required
                                invalid={errors.password || errorState.source === 'email'}
                                className="login__custom-input fw-400"
                                onI2cInput={(val) => {
                                  if (errorState.source === 'email') {
                                    setErrorState({ isError: false, message: '', source: '' });
                                  }
                                  field.onChange(val);
                                }}
                                onI2cBlur={field.onBlur}
                                togglePassword={true}
                              >
                                <I2cIcon slot="hide-password-icon" name="linear-eye" />
                                <I2cIcon slot="show-password-icon" name="linear-eye-slash" />
                              </I2cInput>
                            )}
                          />
                          <div className="login__forget-password">
                            <I2cButton variant="link gray" size="x-small">
                              <Link
                                to="/forgot-password"
                                style={{
                                  textDecoration: 'none',
                                  fontWeight: 400,
                                }}
                              >
                                Forgot Password?
                              </Link>
                            </I2cButton>
                          </div>
                        </div>
                      )}
                      <GoogleReCaptcha
                        onVerify={onVerify}
                        refreshReCaptcha={reValidateRecaptcha}
                      />
                      <div className="login__remember-password">
                        <div className="login__remember">
                          {!isAzureLogin && (
                            <>
                              <I2cSwitch
                                className="switch__label"
                                name=""
                                onI2cChange={() => null}
                              >
                                Remember me
                              </I2cSwitch>
                              <I2cButton
                                loading={login.isLoading}
                                disabled={login.isLoading || !isValid}
                                type="submit"
                                className="login__sign-btn"
                                size="medium"
                              >
                                Sign In
                              </I2cButton>
                            </>
                          )}
                          <I2cButton
                            onClick={handleStatusWindow}
                            type="button"
                            className="signin-with-microsoft-btn"
                            size="medium"
                            variant="secondary gray"
                            disabled={popUp}
                          >
                            <span className="signin-microsoft-span">
                              <img src={microSoftIcon} alt="Microsoft" />
                              Sign in with Microsoft
                            </span>
                          </I2cButton>
                          <ConfirmaionModal
                            open={showConfirmatonModal}
                            setOpen={() => setShowConfirmatonModal(false)}
                            title="Problem Signing In?"
                            headerArt="cs-linear-alert-circle"
                            message={
                              <span className="problem-logging-in-modal-content">
                                Please send your requests/inquiries to{' '}
                                <a
                                  className="problem-logging-in-modal-email-link"
                                  href="mailto:csd@i2cinc.com"
                                >
                                  csd@i2cinc.com
                                </a>
                              </span>
                            }
                            variant="neutral"
                            layout="layoutCenter"
                            cancelButtonText="Close"
                            closeButtonSize="large"
                          >
                            <I2cButton
                              loading={false}
                              type="button"
                              onClick={() => setShowConfirmatonModal(true)}
                              variant="secondary gray"
                              size="medium"
                              className="login__sign-btn login__forgot-btn"
                            >
                              Problem Signing In?
                            </I2cButton>
                          </ConfirmaionModal>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer className="login__footer_mobile">
            <p className="login-aside__footer-text">
              i2c Inc. &copy; {new Date().getFullYear()} All Rights Reserved.
            </p>
          </footer>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoginPage;
